module.exports = __webpack_public_path__ + "img/icon-arrow-right-blue.ad9d29be.svg";